<template>
  <!-- Contenedor de notificaciones: esquina superior derecha -->
  <teleport to="body">
    <div
      class="toast-stack"
      aria-live="polite"
      aria-atomic="true"
    >
      <ToastItem
        v-for="notification in notificationStore.notifications"
        :key="notification.id"
        :id="notification.id"
        :type="notification.type"
        :title="notification.title"
        :message="notification.message"
        :duration="notification.duration"
        class="pointer-events-auto"
        @close="notificationStore.remove"
      />
    </div>
  </teleport>
</template>

<script setup lang="ts">
import { useNotificationStore } from '@/store/notifications';
import ToastItem from './ToastItem.vue';

const notificationStore = useNotificationStore();
</script>

<style scoped>
.toast-stack {
  position: fixed;
  top: max(4.75rem, calc(env(safe-area-inset-top, 0px) + 3.75rem));
  right: max(0.85rem, env(safe-area-inset-right, 0px));
  z-index: 220;
  display: flex;
  flex-direction: column;
  gap: 0.65rem;
  pointer-events: none;
  max-width: calc(100vw - 1.5rem);
}

@media (min-width: 1024px) {
  .toast-stack {
    top: max(1rem, env(safe-area-inset-top, 0px));
    right: max(1rem, env(safe-area-inset-right, 0px));
  }
}
</style>
